"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMenu = exports.identifyNavigationType = exports.getSokoProProductsUrl = void 0;
var types_1 = require("../types");
var back_menu_items_1 = require("./back-menu-items");
var menu_items_1 = require("./menu-items");
var pathnameRegexes = (_a = {},
    _a[types_1.NavigationTypes.BID] = /^\/([\w]+)\/briefcase\/([\d]+)\/bid([^s]|\/|$)([\d]+)?/,
    _a[types_1.NavigationTypes.SITE] = /^\/([\w]+)\/projects\/([\d]+)\/sokosite\/([\S]+)/,
    _a[types_1.NavigationTypes.BRIEFCASE] = /^\/([\w]+)\/briefcase\/([\d]+)/,
    _a[types_1.NavigationTypes.PROJECT] = /^\/([\w]+)\/projects\/([\d]+)/,
    _a[types_1.NavigationTypes.SYSTEM] = /^\/([\w]+)\/admin\//,
    _a[types_1.NavigationTypes.MAIN] = /^\/([\w]+)\/?$/,
    _a);
var getSokoProProductsUrl = function (selectedLanguage) { var _a; return (_a = __SOKOPRO_PRODUCT_URLS__[selectedLanguage]) !== null && _a !== void 0 ? _a : __SOKOPRO_PRODUCT_URLS__['en']; };
exports.getSokoProProductsUrl = getSokoProProductsUrl;
var identifyNavigationType = function (pathname) {
    for (var _i = 0, _a = Object.entries(pathnameRegexes); _i < _a.length; _i++) {
        var _b = _a[_i], type = _b[0], regex = _b[1];
        if (regex.test(pathname)) {
            return types_1.NavigationTypes[type];
        }
    }
    return types_1.NavigationTypes.MAIN;
};
exports.identifyNavigationType = identifyNavigationType;
var createMenu = function (_a) {
    var _b;
    var currentMenu = _a.currentMenu, currentProject = _a.currentProject, features = _a.features, pathname = _a.pathname, selectedLanguage = _a.selectedLanguage, user = _a.user;
    var params = pathnameRegexes[currentMenu].exec(pathname);
    switch (currentMenu) {
        case types_1.NavigationTypes.BID: {
            if (!params || params.length < 3) {
                return {};
            }
            var briefcaseId = parseInt(params[2], 10);
            var bidId = parseInt(params[4], 10) || null;
            return {
                back: (0, back_menu_items_1.createBackToBriefcaseMenuItem)(briefcaseId, selectedLanguage),
                items: (0, menu_items_1.createBidMenuItems)(briefcaseId, bidId, selectedLanguage)
            };
        }
        case types_1.NavigationTypes.BRIEFCASE: {
            if (!params || params.length < 3) {
                return {};
            }
            var briefcaseId = parseInt(params[2], 10);
            return {
                back: (0, back_menu_items_1.createBackToBriefcasesMenuItem)(selectedLanguage),
                items: (0, menu_items_1.createBriefcaseMenuItems)(briefcaseId, selectedLanguage)
            };
        }
        case types_1.NavigationTypes.SYSTEM:
            return {
                back: (0, back_menu_items_1.createBackToProjectsMenuItem)(selectedLanguage),
                items: (0, menu_items_1.createSystemMenuItems)(selectedLanguage)
            };
        case types_1.NavigationTypes.PROJECT:
            return {
                back: (0, back_menu_items_1.createBackToProjectsMenuItem)(selectedLanguage),
                items: (currentProject === null || currentProject === void 0 ? void 0 : currentProject.status) === 'FETCHED'
                    ? (0, menu_items_1.createProjectMenuItems)(currentProject.project.id, selectedLanguage, (_b = currentProject.project.perm) !== null && _b !== void 0 ? _b : 0x00, currentProject.project.showPartiesTab)
                    : null
            };
        case types_1.NavigationTypes.SITE:
            var pathElements = pathname.split('/');
            if (currentProject.status !== 'FETCHED') {
                return {};
            }
            return {
                back: (0, back_menu_items_1.createBackToSiteMenuItem)(currentProject.project.id, selectedLanguage),
                items: pathElements.length > 6
                    ? (0, menu_items_1.createSiteMenuItems)(currentProject.project.id, pathElements[5], pathElements[6], selectedLanguage)
                    : null
            };
        case types_1.NavigationTypes.MAIN:
        default:
            return {
                items: (0, menu_items_1.createDashboardMenuItems)(user, selectedLanguage, features)
            };
    }
};
exports.createMenu = createMenu;
